import src from "./brands.png";
export default { src: src, aspect: 50.7273, width: 3348, height: 66 };